<div>
    <p class="line-height-3 p-0 m-0">
        Scegliere il tipo di shape da esportare:</p><br>
        <p-listbox [options]="exports" [(ngModel)]="selectedExport" optionLabel="name"></p-listbox>
</div>
<div class="buttons-div">
    <button pButton pRipple icon="pi pi-check" (click)="conferma(true)"  label="Conferma" class="p-button-success w-5 mr-2" [disabled]="!selectedExport" ></button>
    <button pButton pRipple icon="pi pi-times" (click)="conferma(false)" label="Annulla" class="p-button-warning w-5 ml-2"></button>
</div>
